<template>
	<div class="tw-flex-col tw--mx-3">
		<div class="px-3 tw-pb-3">
			<c-title-header
				:title="selectedJob.name"
				@go-to-back="goTo(codeStep.returnTo)"></c-title-header>
		</div>
		<div class="tw-flex">
			<div class="px-3 tw-w-3/5">
				<model-stepper
					:current-step="8"
					class="tw-mb-4"
					@code-step="loadCodeStep">
				</model-stepper>
				<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between tw-my-">
					<div class="tw-flex tw-justify-between tw-item-center tw-mb-6">
						<p class="tw-text-app-color-primary text-lg">
							Agregar de 3 a 9 Competencias mas importantes
						</p>
						<p-button
							type="primary"
							@click="choosenSkills">
							Agregar Competencias
						</p-button>
					</div>
					<section class="skills">
						<div class="text-uppercase skills-header tw-px-6 tw-pr-32 tw-py-1 tw-flex tw-justify-between tw-mb-4">
							<span>NOMBRE DE COMPETENCIAS</span>
							<span>REQ.SELEC./CAP.</span>
						</div>
						<div class="skills-list tw-flex tw-flex-col tw-gap-6">
							<skill-item
								:skill="skill"
								v-for="(skill, index) in selectedSkills"
								:key="index"
								@closeClicked="handleRemoveSkillItem(skill)"
								@chooseLevelClicked="handleChooseLevelSkillItem(skill)"
								@chooseQuestionsClicked="handleChooseQuestionsSkillItem(skill)"
								@questionTypeChanged="handleQuestionTypeChanged($event, skill)"
								@onSkillUpdate="handleUpdateFocusedSkill"
							>
							</skill-item>
							<p-empty-message v-if="!selectedSkills.length">
								Escoge de 3 a 9 Competencias<br>más importantes
							</p-empty-message>
						</div>
					</section>
					<div>
						<p-horizontal-divider />
						<div class="tw-text-center">
							<p-button
								type="primary"
								@click="goTo(codeStep.returnTo)"
							>
								Atrás
							</p-button>
							<p-button
								type="secondary"
								:disabled="validate || selectedSkills.length === 0 || selectedSkills.length < codeStep.minCompetencies || selectedSkills.length > 9"
								@click="saveSixthStep"
							>
								Siguiente
							</p-button>
						</div>
					</div>
				</p-card>
			</div>
			<div class="px-3 tw-w-2/5">
				<model-description
					:title="'DESTREZAS REQUERIDAS'"
					:subtitle="'INSTRUCCIONES'">
					<div class="tw-my-4" slot="content">
						<p style="font-size: 13px;" class="tw-text-center">Agregar de 3 a 9 Destrezas requeridas y seleccionar nivel <b>(Destrezas: son comportamientos laborales automatizados por 
							la práctica en la ejecución de la actividad.)</b>
						</p>
						<div class="content-box">
							<table>
								<tr>
									<td style="width: 25%; vertical-align: top;"><p>Paso 1:</p></td>
									<td style="width: 75%">
										<span :style="`color:${$appColors.secondary}`">Escoger Competencias</span><br>
										<span><b>Analizador de Operaciones</b></span>
									</td>
								</tr>
								<br>
								<tr>
									<td style="width: 25%; vertical-align: top;"><p>Paso 2:</p></td>
									<td style="width: 75%">
										<span :style="`color:${$appColors.secondary}`">Escoger Nivel</span><br>
										<span><b>Nivel Alto:</b></span><br>
										<span>(Identificar el sistema de control requerido por una nueva unidad organizacional)</span>
									</td>
								</tr>
								<br>
								<tr>
									<td style="width: 25%; vertical-align: top;"><p>Paso 3:</p></td>
									<td style="width: 75%">
										<span :style="`color:${$appColors.secondary}`">Escoge del listado la <b>Conducta Observable</b> que requiere el puesto.</span><br>
										<span>Escoge del listado (5 PREGUNTAS) la Conducta Observable que requiere el puesto.</span><br>
									</td>
								</tr>
							</table>
						</div>
						<div class="tw-flex tw-flex-col tw-items-center">
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
							>
								Mira nuestro tutorial paso a paso
							</p-button>
						</div>
					</div>
				</model-description>
			</div>
		</div>
		<skill-selection-dialog
			ref="skillSelectionDialog"
			@onSave="handleSelectedSkills($event)"
			:skills="skillData"
			:selected-skills="selectedSkills"
		/>
		<skill-level-selector-dialog
			ref="skillLevelSelectionDialog"
			:skill="focusedSkill"
			@onLevelSelected="handleSkillLevelSelection($event)"
		/>
		<skill-question-selector-dialog
			v-if="focusedSkill.selectedLevel"
			:questions="focusedSkill.selectedLevel.questions"
			:selected-questions="focusedSkill.selectedQuestions"
			:questions-type="focusedSkill.questionsType"
			ref="skillQuestionSelectorDialog"
			@onQuestionSelected="handleOnQuestionSelected($event)"
			>
		</skill-question-selector-dialog>
	</div>
</template>

<script>
import cTitleHeader from '@/modules/job-profile/components/content/c-title-header';
import modelStepper from '@/modules/job-profile/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import SkillSelectionDialog from '@/modules/job-profile/components/sixth-step/skill-selection-dialog';
import SkillLevelSelectorDialog from '@/modules/job-profile/components/sixth-step/skill-level-selector-dialog';
import SkillItem from '@/modules/job-profile/components/sixth-step/skill-item';
import SkillQuestionSelectorDialog from '@/modules/job-profile/components/sixth-step/skill-question-selector-dialog';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';
import { transformSkillData } from '@/modules/three-sixty-evaluation/utils';


const { getLocalData } = helper;

function created() {}

async function loadData() {
	const response = await this.getDataStep('E360');
	this.skillData = transformSkillData(response);
	try {
		const { data: responses } = await this.$httpPraktiko.get(`job-description/detail/${this.codeStep.code}/${this.selectedJob.id}`);
		if (Object.keys(responses).length !== 0) {
			this.selectedSkills = responses.description;
			this.validate = this.selectedSkills
				.some(item => !item.selectedLevel
				|| (item.selectedQuestions && item.selectedQuestions.length === 0));
		}
	} catch (error) {
		this.showGenericError();
	}
}

async function getDataStep(typeKey) {
	const { data } = await this.$http.get(`/hierarchies/${typeKey}`);
	return data;
}

function loadCodeStep(obj) {
	this.codeStep = obj;
}

function choosenSkills() {
	this.$refs.skillSelectionDialog.open();
}

function handleSelectedSkills(selectedSkills) {
	this.selectedSkills = selectedSkills;
	this.$refs.skillSelectionDialog.close();
	this.validate = this.selectedSkills
		.some(item => !item.selectedLevel
		|| (item.selectedQuestions && item.selectedQuestions.length === 0));
}

function handleChooseLevelSkillItem(skillItem) {
	this.focusedSkill = skillItem;
	this.$refs.skillLevelSelectionDialog.open();
}

function handleChooseQuestionsSkillItem(skillItem) {
	this.focusedSkill = skillItem;
	this.$refs.skillQuestionSelectorDialog.open();
}

function handleQuestionTypeChanged(questionsType, skillItem) {
	this.focusedSkill = skillItem;
	this.questionsType = questionsType;
	this.selectedSkills = this.selectedSkills.map((skill) => {
		if (skill.id === this.focusedSkill.id) {
			const newSkill = { ...skill };
			newSkill.questionsType = questionsType;
			return newSkill;
		}
		return skill;
	});
}

function handleOnQuestionSelected(selectedQuestion) {
	const isNotDuplicate = this.focusedSkill.selectedQuestions
		.every(question => question.id !== selectedQuestion.id);
	if (isNotDuplicate) {
		this.focusedSkill.selectedQuestions.push(selectedQuestion);
	}
	this.validate = this.selectedSkills
		.some(item => !item.selectedLevel
		|| (item.selectedQuestions && item.selectedQuestions.length === 0));
}

function handleUpdateFocusedSkill(updatedSkill) {
	this.selectedSkills = this.selectedSkills.map((skill) => {
		if (skill.id === updatedSkill.id) {
			const newSkill = { ...updatedSkill };
			return newSkill;
		}
		return skill;
	});
	this.focusedSkill = { ...updatedSkill };
	this.validate = this.selectedSkills
		.some(item => !item.selectedLevel
		|| (item.selectedQuestions && item.selectedQuestions.length === 0));
}

function handleRemoveSkillItem(skillItem) {
	this.selectedSkills = this.selectedSkills.filter(element => element.id !== skillItem.id);
	this.validate = this.selectedSkills
		.some(item => !item.selectedLevel
		|| (item.selectedQuestions && item.selectedQuestions.length === 0));
}


function handleSkillLevelSelection(skillLevelSelected) {
	// const dataWithoutQuestions = skillLevelSelected;
	// delete dataWithoutQuestions.questions;
	this.focusedSkill = {
		...this.focusedSkill,
		selectedLevel: skillLevelSelected,
		questionsType: undefined,
		selectedQuestions: [],
	};
	const { questions, ...focusedSkillWithoutQuestions } = this.focusedSkill;
	this.focusedSkill = focusedSkillWithoutQuestions;
	this.selectedSkills = this.selectedSkills.map((skl) => {
		if (skl.id === this.focusedSkill.id) {
			return { ...this.focusedSkill };
		}
		return skl;
	});
	this.validate = this.selectedSkills
		.some(item => !item.selectedLevel
		|| (item.selectedQuestions && item.selectedQuestions.length === 0));
}

async function saveSixthStep() {
	const body = {
		description: this.selectedSkills,
		typeDescriptionCode: this.codeStep.code,
		jobId: this.selectedJob.id,
	};
	try {
		await this.$httpPraktiko.post('job-description', body);
		this.showNotification('Competencias Requeridas Guardadas Exitosamente');
		this.goTo(this.codeStep.goTo);
	} catch (error) {
		this.showGenericError();
	}
}


export default {
	name: 'job-required-competencies',
	data() {
		return {
			codeStep: {},
			skillData: [],
			selectedSkills: [],
			focusedSkill: {},
			validate: true,
			questionsType: {},
		};
	},
	created,
	mounted() {},
	components: {
		cTitleHeader,
		modelStepper,
		PCard,
		PEmptyMessage,
		PButton,
		PHorizontalDivider,
		modelDescription,
		SkillSelectionDialog,
		SkillLevelSelectorDialog,
		SkillQuestionSelectorDialog,
		SkillItem,
	},
	methods: {
		loadData,
		loadCodeStep,
		getDataStep,
		choosenSkills,
		handleSelectedSkills,
		handleChooseLevelSkillItem,
		handleChooseQuestionsSkillItem,
		handleQuestionTypeChanged,
		handleOnQuestionSelected,
		handleUpdateFocusedSkill,
		handleRemoveSkillItem,
		handleSkillLevelSelection,
		saveSixthStep,
	},
	computed: {
		...mapState('jobProfile', {
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
			// pathOr([], ['selectedJob']) || getLocalData('selectedJob'),
		}),
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.skills {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
	&-list {
		overflow: auto;
		height: 50vh;
		color: color(gray-sidebar) !important;
	}
}
.content-box {
	border: 1px solid color(border-gray);
	background-color: color(gray-light);
	border-radius: 5px;
	height: auto;
	width: 100%;
	padding: 10px;
	table {
		width: 100%;
		// border-collapse: collapse;
		text-align: left;
		font-size: 12px;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/sixth-page/job-required-competencies.vue